module.exports = __webpack_public_path__ + "static/media/LitReviews.82fc5348.png";